import React, {ReactElement} from 'react';
import {connect} from 'react-redux';
import {AppDispatch, RootState} from "../../../../store/store";
import {Box} from "@mui/material";
import {logException} from "../../../../controllers/system";
import TopBar from "../topBar/topBar";

type IProps = {
    children: ReactElement | ReactElement[]
}

const mapStateToProps = (state: RootState) => {
    return {
        redirect: state.app.redirect
    };
}

const mapDispatchToProps = (dispatch: AppDispatch) => {
    return {
    };
};

type ReduxType = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & IProps;

class Layout extends React.Component<ReduxType> {

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        logException({error, errorInfo});
    }

    render() {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%', overflow: 'auto' }}>
                <Box sx={{p:1}}>
                    <TopBar />
                </Box>
                <Box sx={{p:1, display: 'flex', flexGrow: 1, overflow: 'auto', backgroundColor: '#101418'}}>
                    {this.props.children}
                </Box>
            </Box>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
